var map = {
	"./amex-large.svg": 96109,
	"./amex-stacked.png": 41267,
	"./amex-stacked.svg": 51971,
	"./amex.jpg": 94379,
	"./blue-redirect-info-icon.svg": 41750,
	"./budgetz-long.svg": 51008,
	"./budgetz.svg": 89709,
	"./cal-diners-stacked.png": 46328,
	"./cal-diners-stacked.svg": 88020,
	"./cal-diners.svg": 32628,
	"./cal-stacked.png": 62908,
	"./cal.jpg": 32820,
	"./discount-large.svg": 87233,
	"./discount-small.svg": 47961,
	"./discount.jpg": 8963,
	"./doar-large.svg": 10802,
	"./doar-small.svg": 91574,
	"./doar.jpg": 41412,
	"./egud.jpg": 46525,
	"./habeinleumi-large.svg": 78989,
	"./habeinleumi-small.svg": 73941,
	"./habenleumi.jpg": 95522,
	"./hapoalim-large.svg": 24035,
	"./hapoalim-small.svg": 90119,
	"./igud-large.svg": 859,
	"./igud-small.svg": 42879,
	"./isracard-large.svg": 64413,
	"./isracard-logo.png": 66975,
	"./isracard-stacked.svg": 7347,
	"./isracard.jpg": 77671,
	"./jerusalem-large.jpg": 50060,
	"./jerusalem.jpg": 43834,
	"./leumi-large.svg": 80424,
	"./leumi-obk-small.svg": 4697,
	"./leumi-small.svg": 95056,
	"./leumi.jpg": 33356,
	"./leumicard-max-stacked.png": 3567,
	"./leumicard-max.png": 59375,
	"./leumicard-stacked.png": 30962,
	"./leumicard.jpg": 53278,
	"./masad.jpg": 8682,
	"./massad-large.svg": 33319,
	"./massad-small.svg": 25995,
	"./max-leumi-stacked.svg": 99503,
	"./meitav.svg": 92398,
	"./mercantil.jpg": 11213,
	"./mercantile-large.png": 68718,
	"./mercantile-small@3x.jpg": 47537,
	"./mizrachi-large.svg": 14219,
	"./mizrachi-small.svg": 72559,
	"./mizrahi.jpg": 31210,
	"./one-zero.png": 4725,
	"./otsar-large.jpg": 40255,
	"./otsar-large.png": 45295,
	"./otzarhahayal.jpg": 24392,
	"./pagi-large.png": 84269,
	"./pagi.jpg": 57243,
	"./pepper-badge-large.svg": 56954,
	"./pepper-large.svg": 38632,
	"./pepper-redirect-info-icon.svg": 99542,
	"./pepper.png": 43854,
	"./poalim.jpg": 23748,
	"./ubank-large.png": 25013,
	"./ubank.jpg": 16355,
	"./yahav-large.jpg": 99221,
	"./yahav-new-large.png": 6512,
	"./yahav.jpg": 76467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70836;